import { mouse as d3mouse, event as d3event } from 'd3-selection'
import findBlock from './findBlockInstanceByCoordinates'
import findMapObjectByCoordinates from './findMapObjectByCoordinates'

class Tooltip {
  constructor(map) {
    this.map = map

    this.map.container.on('mousemove', () => this.onMousemove(d3mouse(this.map.container.node())))
  }

  update = (map) => {
    this.map = map
  }

  onMousemove = (mouse) => {
    if (d3event.srcElement.id !== 'floorImage') return this.hideTooltip()
    const { container, selectedItem, dx, dy, xScale, yScale, transform, editingBlocks, handles } =
      this.map

    if (selectedItem) {
      const x = xScale.invert(mouse[0] - dx * transform.k)
      const y = yScale.invert(mouse[1] - dy * transform.k)
      return this.map.updatePreview({ x, y })
    }

    if (editingBlocks) {
      if (handles) {
        const handle = handles.reduce((result, h) => {
          if (
            mouse[0] >= h.cx - h.r &&
            mouse[0] <= h.cx + h.r &&
            mouse[1] >= h.cy - h.r &&
            mouse[1] <= h.cy + h.r
          ) {
            return h
          }

          return result
        }, null)

        if (handle) {
          container.style('cursor', handle.cursor)
          return
        }
      }

      const bi = findBlock(mouse, this.map)
      this.map.highlightBlockInstance(bi)
      container.style('cursor', bi ? 'pointer' : 'default')
      return
    }

    const mo = findMapObjectByCoordinates(mouse, this.map)

    if (mo) {
      this.map.handleSubscriptions(
        'hover',
        mo
          ? {
              mapObject: mo,
              mouse,
            }
          : null
      )
      container.style('cursor', 'pointer')
      return
    }

    this.map.handleSubscriptions('hover', null)

    container.style('cursor', 'default')
  }

  hideTooltip = () => {
    this.map.handleSubscriptions('hover', null)
  }
}

export default Tooltip
